module.exports = __webpack_public_path__ + "img/start_game_day.9925f317.png";